import React, { createContext, useCallback, useContext, useState } from 'react'

import useHost from '../Host/hooks/useHost'
import { setAuthToken } from '../utils/api/authToken'

type ContextState = {
  authorized: boolean
}

const StoreContext = createContext<ContextState | undefined>(undefined)

function AuthProvider({ children }: React.PropsWithChildren) {
  const [authorized, setAuthorized] = useState(false)

  useHost(
    'SET_AUTH_TOKEN',
    useCallback((value?: string) => {
      setAuthorized(!!value)
      setAuthToken(value)
    }, []),
  )

  return <StoreContext.Provider value={{ authorized }}>{children}</StoreContext.Provider>
}
const useAuth = () => {
  const context = useContext(StoreContext)
  if (!context) {
    throw new Error('useAuth must be used within a AuthProvider')
  }
  return context
}

export { useAuth }
export default AuthProvider
